import type { Resource } from '../../';
export const forms_field_email: Resource = {"default":"Email Address"};
